import { Warning } from '../../../assets/icons'
import { SVGWrapper } from '../../../components'
import { Section } from '../styles'
import dayjs from 'dayjs'

const CatchUpOver64 = ({ standardCatchup, standardLimit }) => {
  return (
    <Section.ActionItemsMessage warning>
      <SVGWrapper svg={Warning} fill='#3A4D57' size='large' />{' '}
      <Section.ActionItemMessageText>
        Be aware: You may need to reduce your retirement plan contributions. The IRS permits those
        aged 64+ in the current calendar year to make catch-up contributions of up to the regular
        catch-up contribution limit of ${standardCatchup?.maximumAmount?.toLocaleString()} for{' '}
        {dayjs().year()}. With the standard contribution limit of ${standardLimit?.toLocaleString()}
        , this means the maximum contribution you can make to your company’s retirement plan is $
        {(standardLimit + standardCatchup?.maximumAmount).toLocaleString()}.
      </Section.ActionItemMessageText>
    </Section.ActionItemsMessage>
  )
}
export default CatchUpOver64
